import { render, staticRenderFns } from "./180.vue?vue&type=template&id=f33d494c&scoped=true&"
var script = {}
import style0 from "./180.vue?vue&type=style&index=0&id=f33d494c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33d494c",
  null
  
)

export default component.exports